import { Field } from '../interfaces/Field';
import { XdmEntityObject } from '../models';
import { DatePlaceholders } from '../enums/DatePlaceholders';
import { getLocaleDateString } from './dateUtils';
import { getEntityNameProperty } from './xdmUtils';
import { FieldsType } from '../constants/FieldsType';
import React from 'react';
import { XdmContextView } from '../components/XdmContextView/XdmContextView';

export enum ViewMode {
  DataTable,
  View,
}

export const getValueOfXdmField = (fieldInfo: Field, value: any) => {
  if (!fieldInfo.xdm) {
    return '';
  }

  const nameProperty = getEntityNameProperty(fieldInfo.xdm.mappings);

  if (!fieldInfo.xdm.isArray) {
    return value && value[nameProperty];
  }

  return (value as XdmEntityObject[])
    .map((item) => {
      return item[nameProperty];
    })
    .join(', ');
};

export const getFormattedValue = (
  value: any,
  fieldInfo: Field,
  viewMode: ViewMode
) => {
  const { type } = fieldInfo;
  switch (type.toLowerCase()) {
    case FieldsType.dateTime:
      return getLocaleDateString(value, DatePlaceholders.na);
    case FieldsType.xdm: {
      return getValueOfXdmField(fieldInfo, value);
    }
    case FieldsType.bool: {
      return value === true ||
        value === 1 ||
        value.toString()?.toLowerCase() === 'true'
        ? 'Yes'
        : 'No';
    }
    case FieldsType.string: {
      if (!fieldInfo.isArray) {
        return value;
      } else {
        return Array.isArray(value) && value.join(', ');
      }
    }
    case FieldsType.multiSelect: {
      return value?.join(', ');
    }
    case FieldsType.xdmContext: {
      if (viewMode === ViewMode.DataTable) {
        return 'N/A';
      }

      if (!fieldInfo.xdmContext) {
        throw new Error('Xdm context is not configured as expected');
      }

      return <XdmContextView field={fieldInfo} value={value}></XdmContextView>;
    }
    default:
      return value;
  }
};
